import { useLocation } from 'react-router-dom'
import { startAdminGoogleLogin } from '@/actions/authActions'
import { useAppDispatch } from '@/utils/typeHelpers'
import { TypographyStyles } from '@/styles'
import { Button, Card, Image, Text } from '@/ui'

export const AdminLogin = () => {
  const dispatch = useAppDispatch()
  // A route guard that bounces an unauthenticated admin here appends the
  // originally-requested path as `?redirect=`; carry it through SSO so the
  // callback can return them to their deep link.
  const { search } = useLocation()
  const redirectPath = new URLSearchParams(search).get('redirect') ?? undefined

  return (
    <div className="finances login w-full background-app h-full">
      <div className="w-full text-center pt-12 flex flex-col items-center space-y-6">
        <div className="flex justify-center">
          <Image
            src="https://heard-images.s3.us-west-1.amazonaws.com/heard_logo_green_2x.png"
            alt="heard logo"
            height={20}
            width={100}
          />
        </div>

        <Text variant={TypographyStyles.H2}>Admin sign in</Text>

        <div className="flex justify-center w-full">
          <Card className="w-full md:w-3/4 lg:w-1/2">
            <Button
              onClick={() => dispatch(startAdminGoogleLogin(redirectPath))}
            >
              Sign in with Google
            </Button>
          </Card>
        </div>
      </div>
    </div>
  )
}
